import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { NumberFormatter } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import { calculateSalePercentage } from '../../utils/ProductUtils';
import PropTypes from 'prop-types';

const SaleDelta = ({ prices, translate }) => {
  const { price, salePrice, onSale } = prices;
  if (!onSale) return null;

  const { Text } = UX2.Element;
  const delta = price - salePrice;
  const percentage = calculateSalePercentage(price, salePrice);
  if (delta <= 0 || percentage < 1) return null;

  const deltaFormatted = NumberFormatter.toFormattedCurrency(delta, 2, 1);
  const formattedPercentage = NumberFormatter.toFormattedPercentage(percentage, 0, 0);

  const youSaveTranslation = translate('products.you_save', {
    amount: deltaFormatted,
    percentage: formattedPercentage
  });

  return <Text alert>{ youSaveTranslation }</Text>;
};

SaleDelta.propTypes = {
  prices: PropTypes.object,
  translate: PropTypes.object
};

export default SaleDelta;
